module.exports = "/_next/static/resources/inter-roman.var-9db9a1d3f635b4d23d47970234763fdf.woff2";